/**
 * "Assignee option" tick on Admin → Teams: whether a person is offered in the
 * task assignee pickers (task reassign, workflow template task assignee,
 * workflow role holders). Email recipient and Assigned Adviser pickers ignore it,
 * and the server never refuses an assignment because of it.
 *
 * Stored as `assigneeOption` on the roster member (admin_teams users[]) and on
 * users/{email}. A blank value means ticked, except for paraplanner staff, who
 * start unticked (most of them never take tasks).
 *
 * CommonJS body so Node scripts can require() it and webpack can bundle it.
 */

function defaultAssigneeOption(role) {
  return role !== 'paraplanner';
}

/** `person` is a users/{email} record or a roster member; `role` overrides person.role (roster rows). */
function isAssigneeOption(person, role) {
  const value = person ? person.assigneeOption : undefined;
  if (value === true || value === false) return value;
  return defaultAssigneeOption(role || (person && person.role));
}

module.exports = {
  defaultAssigneeOption,
  isAssigneeOption,
};
